/**
 * A human-readable message for a failed API call.
 *
 * DRF rejects invalid writes with field-keyed bodies ({field: [messages]})
 * rather than a `detail` string; interpolating those directly into a toast
 * renders "[object Object]". This flattens whatever shape came back.
 */
export const describeApiError = (error) => {
    const data = error?.response?.data;
    if (typeof data === 'string' && data.trim()) return data;
    if (Array.isArray(data)) return data.map(describeMessage).join('\n');
    if (data && typeof data === 'object') {
        if (data.detail) return describeMessage(data.detail);
        const lines = Object.entries(data).map(([field, messages]) => {
            const text = (Array.isArray(messages) ? messages : [messages]).map(describeMessage).join(' ');
            return field === 'non_field_errors' ? text : `${field}: ${text}`;
        });
        if (lines.length) return lines.join('\n');
    }
    return error?.message || 'Unknown error';
};

const describeMessage = (message) => (typeof message === 'string' ? message : JSON.stringify(message));
